const footerEl = document.querySelector('.footer');
if (footerEl) {
  const applyLinkedinSec = document.querySelector('.apply-linkedin-sec');

  const setApplyLinkedinSecHeight = () => {
    if (applyLinkedinSec) {
      const footerHeight = footerEl.offsetHeight;
      applyLinkedinSec.style.minHeight = `calc(100vh - ${footerHeight + 1}px)`;
    }
  };

  setApplyLinkedinSecHeight();

  window.addEventListener('resize', setApplyLinkedinSecHeight);
}